import type { TWellBroadcastWidgetSerializedInternalState } from './ImageBroadcastWidget.entity';

export function parseWellImageBroadcastWidgetInternalState(state: object): TWellBroadcastWidgetSerializedInternalState {
  let wellId: number | null = null;
  let stateParams: object = {};

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && !!state.stateParams) {
    stateParams = state.stateParams;
  }

  return {
    wellId,
    stateParams,
  };
}
